module.exports = __webpack_public_path__ + "img/right-more-2.6dcbd172.png";